// extracted by mini-css-extract-plugin
export default {"slide-section":"SlideSection_slide-section__wVBQf","header":"SlideSection_header__kTiI9"};